import { DsIcon } from '../../../../components/icons/DsIcon';
import useHorizontalNav from '../../../@menu/hooks/useHorizontalNav';
// Hook Imports
import useVerticalNav from '../../../@menu/hooks/useVerticalNav';

export const HorizontalNavToggle = () => {
  // Hooks
  const { toggleVerticalNav } = useVerticalNav();
  const { isBreakpointReached } = useHorizontalNav();

  // Toggle Vertical Nav
  const handleClick = () => {
    toggleVerticalNav();
  };

  return (
    <>
      {/* <DsIcon icon="JUSTIFIED" onClick={handleClick} /> */}
      {/* Comment following code and uncomment this code in order to toggle menu on desktop screens as well */}
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      {isBreakpointReached && <DsIcon icon="JUSTIFIED" onClick={handleClick} />}
    </>
  );
};
